import React from "react";
import FeatureBlock from "./elements/FeatureBlock";
import CenteredContentWrapper from '../elements/CenteredContentWrapper';
import { getImage } from "../../helpers/images";

const title = 'Your new sound source';

export default class SoundLibrariesBlock extends React.PureComponent {
    render() {
        return (
            <div className={'sound-libraries'}>
                <CenteredContentWrapper>
                    <FeatureBlock
                        isButtonLabel={false}
                        title={title}
                        className={'sounds'}
                        isCatalogButton={true}
                    >Capsule is constantly refreshed with unique sounds. Sit back, enjoy the ride, and let the ideas come to you with these fresh sources of inspiration.
                    </FeatureBlock>
                </CenteredContentWrapper>

                <img alt={title} className={'mobile-element'} src={getImage('bg/sound-libraries-4.webp')}/>
            </div>
        );
    }
}

